import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebase';

const LS_KEYS = ['isAuthenticated', 'isAdmin', 'isFullAdmin', 'userRole', 'staffPermissions'];

export function clearStaffSessionStorage() {
  LS_KEYS.forEach((k) => localStorage.removeItem(k));
}

/**
 * Cierra sesión Firebase, limpia flags de panel y redirige al login.
 */
export async function forceSignOutStaff(reason = '') {
  clearStaffSessionStorage();
  try {
    await signOut(auth);
  } catch (_) {
    /* ignore */
  }
  if (typeof window === 'undefined') return;
  const path = window.location.pathname || '';
  if (path.startsWith('/login')) return;
  const q = reason ? `?reason=${encodeURIComponent(reason)}` : '';
  window.location.replace(`/login${q}`);
}

const TOKEN_CHECK_MS = 45 * 1000;

/**
 * Vigila sesión staff: listener a users/{uid}.authDisabled, refresh de token y pestaña visible.
 * Solo actúa si hay sesión de panel (localStorage isAuthenticated).
 */
export function initStaffSessionWatch() {
  let unsubDoc = null;
  let intervalId = null;

  const stopDoc = () => {
    if (unsubDoc) {
      unsubDoc();
      unsubDoc = null;
    }
  };

  const stopInterval = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const refreshTokenOrKick = () => {
    const u = auth.currentUser;
    if (!u || localStorage.getItem('isAuthenticated') !== 'true') return;
    u.getIdToken(true).catch(() => {
      forceSignOutStaff('session');
    });
  };

  const onVisibility = () => {
    if (document.visibilityState === 'visible') refreshTokenOrKick();
  };

  const unsubAuth = onAuthStateChanged(auth, (user) => {
    stopDoc();
    stopInterval();
    if (!user) return;
    if (localStorage.getItem('isAuthenticated') !== 'true') return;

    const ref = doc(db, 'users', user.uid);
    unsubDoc = onSnapshot(
      ref,
      (snap) => {
        if (!snap.exists()) return;
        if (snap.data().authDisabled === true) {
          forceSignOutStaff('disabled');
        }
      },
      () => {}
    );

    refreshTokenOrKick();
    intervalId = setInterval(refreshTokenOrKick, TOKEN_CHECK_MS);
  });

  document.addEventListener('visibilitychange', onVisibility);

  return () => {
    unsubAuth();
    stopDoc();
    stopInterval();
    document.removeEventListener('visibilitychange', onVisibility);
  };
}
